import React, { Component } from "react";

import {
  Wrapper,
  Row,
  Card,
  Copy,
  Bold,
  Button,
  Icon
} from "app/NativeComponents/common";
import AddressItem from "./AddressItem";
import SkipTraceButton from "../SkipTraceButton";

class MailingAddresses extends Component {
  render() {
    const { colors, owner_info, selected_owner_tab } = this.props;

    if (owner_info && selected_owner_tab == "mailing_addresses") {
      const main_address = {
        owner_mailing_address_id: "main_address",
        address: owner_info.owner_address,
        address2: owner_info.owner_address2,
        city: owner_info.owner_address_city,
        state: owner_info.owner_address_state,
        zip: owner_info.owner_address_zip,
        send_to_address: owner_info.send_to_owner_address,
        custom_owner: owner_info.custom_owner,
        main_address: true
      };

      return (
        <Wrapper
          style={{
            backgroundColor: colors.background_color,
            paddingBottom: 0
          }}
        >
          <AddressItem mailing_address={main_address} {...this.props} />

          {owner_info.mailing_addresses &&
            owner_info.mailing_addresses.map((mailing_address, i) => {
              return (
                <AddressItem
                  key={`${mailing_address.address}${mailing_address.city}`}
                  mailing_address={mailing_address}
                  {...this.props}
                />
              );
            })}

          <Row style={{ justifyContent: "flex-end", padding: 10 }}>
            <Button
              onPress={() => {
                this.props.setEditModal({
                  title: "Add Mailing Address",
                  description:
                    "Add an additional mailing address for " +
                    this.props.owner_info.owner_name,
                  slug: "add-owner-mailing-address",
                  type: "add_owner_mailing_address",
                  fields: {
                    address: "",
                    address2: "",
                    city: "",
                    state: "",
                    zip: "",
                    send_to_address: 0
                  },
                  save_button_text: "Add Mailing Address",
                  modalAction: ({ fields }) => {
                    this.props.updateOwnerInfo({
                      token: this.props.token,
                      deal_id: this.props.active_property.deal.id,
                      type: "create_mailing_address",
                      address: fields.address,
                      address2: fields.address2,
                      city: fields.city,
                      state: fields.state,
                      zip: fields.zip,
                      send_to_address: fields.send_to_address,
                      onSuccess: () => {}
                    });
                  },
                  cancelAction: () => {},
                  fieldsUpdated: fields => {}
                });
                this.props.appRedirect({
                  redirect: "goForward",
                  payload: { add: "add-owner-mailing-address" }
                });
              }}
            >
              <Row>
                <Icon icon="add" size={18} color={colors.success_color} />
                <Copy style={{ marginLeft: 3, color: colors.success_color }}>
                  Add Mailing Address
                </Copy>
              </Row>
            </Button>
          </Row>
        </Wrapper>
      );
    }

    return null;
  }
}

export default MailingAddresses;
